import { render } from "./LoginAuthentication.vue?vue&type=template&id=1c5a2af5&scoped=true"
import script from "./LoginAuthentication.vue?vue&type=script&lang=js"
export * from "./LoginAuthentication.vue?vue&type=script&lang=js"

import "@/css/components/login-authentication.css?vue&type=style&index=0&id=1c5a2af5&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5a2af5"]])

export default __exports__